import { Badge, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import React from "react";
const InGeniusSavingBadge = (props) => {
    const i18n = useI18n();
    const badgeText = props.variant === "percentage"
        ? i18n.trans(t("flights_genius_saving_badge_percentage_off", {
            variables: {
                percentage: `${props.percentageDiscount}%`
            }
        }))
        : i18n.trans(t("flights_fd_campaign_saving_amount_badge", {
            variables: {
                currency_price_saving: props.savingsAmount
            }
        }));
    return (React.createElement(Stack, { direction: "row" },
        React.createElement(Text, null, i18n.trans(t("flights_fd_campaign_flight_price"))),
        React.createElement(Badge, { variant: "brand-genius-primary", text: badgeText, alternative: true })));
};
export default InGeniusSavingBadge;
